import React from 'react'
import { motion } from 'framer-motion'



const Logo = () => {
  return (
    <div className='flex items-center justify-center mt-2'>
        <motion.a href="/"
                    className='w-16 h-16 text-light flex items-center justify-center rounded-full text-2xl font-bold bg-dark
                               border border-solid border-transparent dark:border-light'
                    whileHover={{ scale: 1.08, transition: { duration: 0.2 } }}>
            ET
        </motion.a>
    </div>
  )
}

export default Logo